import { Button } from "@devhop/ui";
import { config } from "@/shared/lib/config";
import { fetchLookupForInfinite, hydrateLookupItems } from "@/shared/lib/utils";
import { InfiniteMultiCombobox } from "@/shared/ui/InfiniteMultiCombobox";

export type PerformerOption = { id: string; name: string };

type PerformerMultiSelectProps = {
  label?: string;
  required?: boolean;
  values: string[];
  onValuesChange: (values: string[]) => void;
  lookupUrl?: string;
  queryKeyPrefix: string[];
  disabled?: boolean;
  hint?: string;
  onSelectAllFromResults?: (ids: string[]) => void;
};

const DEFAULT_LOOKUP = `${config.apiUrl}/performers/lookup`;

export function PerformerMultiSelect({
  label = "ນັກສະແດງ",
  required,
  values,
  onValuesChange,
  lookupUrl = DEFAULT_LOOKUP,
  queryKeyPrefix,
  disabled,
  hint,
}: PerformerMultiSelectProps) {
  const clearSelection = () => onValuesChange([]);

  return (
    <div className="flex min-h-0 flex-col gap-2">
      <div className="flex items-center justify-between gap-2">
        <p className="font-medium text-sm">
          {label}
          {required ? <span className="text-destructive"> *</span> : null}
        </p>
        {values.length > 0 && (
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="h-7 px-2 text-xs"
            disabled={disabled}
            onClick={clearSelection}
          >
            ລ້າງ
          </Button>
        )}
      </div>

      <InfiniteMultiCombobox<PerformerOption>
        values={values}
        onValuesChange={onValuesChange}
        placeholder="ຄົ້ນຫາ ແລະ ເລືອກຫຼາຍຄົນ..."
        queryKey={queryKeyPrefix}
        queryFn={({ search, pageParam }) =>
          fetchLookupForInfinite<PerformerOption>(lookupUrl, {
            search,
            pageParam,
          })
        }
        preloadQueryFn={(ids) =>
          hydrateLookupItems<PerformerOption>(lookupUrl, ids)
        }
        getLabel={(item) => item.name}
        getValue={(item) => item.id}
        clearable
      />

      {values.length > 0 ? (
        <p className="text-muted-foreground text-xs">
          ເລືອກແລ້ວ {values.length} ຄົນ
        </p>
      ) : hint ? (
        <p className="text-muted-foreground text-xs">{hint}</p>
      ) : null}
    </div>
  );
}
